import { mapHeaders } from "./headers.js";
import debug from "../debug.js";
const d = debug.extend("mapResponse");
export const getMediaType = (headers) => {
    const mappedHeaders = mapHeaders(headers);
    const rawMediaType = mappedHeaders["content-type"];
    // when header includes meta data like "base64; charset=UTF-8"
    return rawMediaType ? rawMediaType.split(";")[0] : undefined;
};
export const mapBody = async (body, headers) => {
    const mediaType = getMediaType(headers);
    let content;
    try {
        switch (mediaType?.toLowerCase()) {
            case "application/json":
                content = await body.json();
                break;
            default:
                content = await body.text();
                break;
        }
    }
    catch (err) {
        d("Error while decoding body of response: %O", err);
    }
    d("mapped body with media type %s to %o", mediaType, content);
    return content;
};
export const mapResponse = async (response, operation) => {
    const mediaType = getMediaType(response.headers);
    return {
        status: response.status,
        url: response.url,
        mediaType,
        content: await mapBody(response, response.headers),
        headers: mapHeaders(response.headers),
        operation,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaHR0cC9yZXNwb25zZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBQzFDLE9BQU8sS0FBSyxNQUFNLGFBQWEsQ0FBQztBQUdoQyxNQUFNLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFDO0FBRXRDLE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxDQUFDLE9BQXFDLEVBQXNCLEVBQUU7SUFDdEYsTUFBTSxhQUFhLEdBQUcsVUFBVSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBRTFDLE1BQU0sWUFBWSxHQUFHLGFBQWEsQ0FBQyxjQUFjLENBQUMsQ0FBQztJQUNuRCw4REFBOEQ7SUFDOUQsT0FBTyxZQUFZLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQztBQUNqRSxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxPQUFPLEdBQUcsS0FBSyxFQUFFLElBQVUsRUFBRSxPQUFxQyxFQUFnQixFQUFFO0lBQzdGLE1BQU0sU0FBUyxHQUFHLFlBQVksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUV4QyxJQUFJLE9BQVksQ0FBQztJQUVqQixJQUFJO1FBQ0EsUUFBUSxTQUFTLEVBQUUsV0FBVyxFQUFFLEVBQUU7WUFDOUIsS0FBSyxrQkFBa0I7Z0JBQ25CLE9BQU8sR0FBRyxNQUFNLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztnQkFDNUIsTUFBTTtZQUNWO2dCQUNJLE9BQU8sR0FBRyxNQUFNLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztnQkFDNUIsTUFBTTtTQUNiO0tBQ0o7SUFBQyxPQUFPLEdBQUcsRUFBRTtRQUNWLENBQUMsQ0FBQywyQ0FBMkMsRUFBRSxHQUFHLENBQUMsQ0FBQztLQUN2RDtJQUVELENBQUMsQ0FBQyxzQ0FBc0MsRUFBRSxTQUFTLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFFOUQsT0FBTyxPQUFPLENBQUM7QUFDbkIsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLEtBQUssRUFBRSxRQUFrQixFQUFFLFNBQXlDLEVBQTRCLEVBQUU7SUFDekgsTUFBTSxTQUFTLEdBQUcsWUFBWSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUVqRCxPQUFPO1FBQ0gsTUFBTSxFQUFFLFFBQVEsQ0FBQyxNQUFNO1FBQ3ZCLEdBQUcsRUFBRSxRQUFRLENBQUMsR0FBRztRQUNqQixTQUFTO1FBQ1QsT0FBTyxFQUFFLE1BQU0sT0FBTyxDQUFDLFFBQVEsRUFBRSxRQUFRLENBQUMsT0FBTyxDQUFDO1FBQ2xELE9BQU8sRUFBRSxVQUFVLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztRQUNyQyxTQUFTO0tBQ1osQ0FBQztBQUNOLENBQUMsQ0FBQyJ9